import React, {Component} from 'react';
import classnames from 'classnames';
import Modal from './Modal';
import './BottomSheetModal.less';

class BottomSheet extends Component {
    static propTypes = {
        ...Modal.propTypes
    };
    static defaultProps = {
        ...Modal.defaultProps
    };

    constructor(props) {
        super(props);
        this.modal = React.createRef();

        this.timeoutId = null;

        this.x = 0;
        this.y = 0;
        this.modalContent = null;
        this.modalBackdrop = null;

        this.state = {
            panPct: 0
        };
    }

    handleOpen = (modalStructure, modalBodyElement) => {
        window.document.body.style.top = `-${window.scrollY}px`;
        this.modalContent = modalBodyElement.parentElement;
        this.modalBackdrop = modalStructure.dialog.previousSibling;
        this.toggleTouchHandlers(true);
        if (this.props.onModalOpen) {
            this.props.onModalOpen(modalStructure, modalBodyElement);
        }
    };

    handleClose = () => {
        // fix to enable backdrop fade when swiping closed modal
        if (this.modalBackdrop?.style?.opacity === 0) {
            this.modalBackdrop.style.opacity = '';
            this.modalBackdrop.style.transition = '';
        }
        this.toggleTouchHandlers(false);
        if (this.props.onModalClose) {
            this.props.onModalClose();
        }
    };

    toggleTouchHandlers = (add) => {
        const fn = add ? 'addEventListener' : 'removeEventListener';
        this.modalContent[fn]('touchstart', this.onTouchStart, {
            passive: false
        });
        this.modalContent[fn]('touchmove', this.onTouchMove, {passive: false});
        this.modalContent[fn]('touchend', this.onTouchEnd, {passive: false});
    };

    transition = (reset) => {
        const transitionDuration = 250;
        this.applyTransitionStyles({reset, transitionDuration});
        this.setState({panPct: 0});
        clearTimeout(this.timeoutId);
        this.timeoutId = setTimeout(() => {
            // fix to enable backdrop fade when closed modal after it was swiped but reset
            if (reset) {
                this.modalBackdrop.style.opacity = '';
                this.modalBackdrop.style.transition = '';
            }
            if (!reset && this.props.onClose) {
                this.props.onClose();
            }
        }, transitionDuration);
    };

    applyPanStyles = ({panPct}) => {
        this.modalContent.style.transition = 'none';
        this.modalContent.style.transform = `translateY(${panPct}%)`;
        this.modalBackdrop.style.transition = 'none';
        this.modalBackdrop.style.opacity = ((1 - panPct / 100) * 0.8).toFixed(
            4
        );
    };

    applyTransitionStyles = ({reset, transitionDuration}) => {
        this.modalContent.style.transition = `transform ${transitionDuration}ms ease`;
        this.modalContent.style.transform = `translateY(${reset ? 0 : 100}%)`;
        this.modalBackdrop.style.transition = `opacity ${transitionDuration}ms ease`;
        this.modalBackdrop.style.opacity = reset ? 0.8 : 0;
    };

    onTouchStart = (e) => {
        this.x = e.touches[0].clientX;
        this.y = e.touches[0].clientY;
    };

    onTouchMove = (e) => {
        const clientX = e.touches[0].clientX;
        const clientY = e.touches[0].clientY;
        const xDiff = this.x - clientX;
        const yDiff = this.y - clientY;
        this.touchMoved = true;
        // determine pan axis for this swipe

        // This will stop touch interactions if you scroll sideways to start, need to check again

        if (!this.panAxis || this.panAxis === 'horizontal') {
            const yDiffAbs = Math.abs(yDiff);
            this.panAxis =
                Math.abs(xDiff) > yDiffAbs ? 'horizontal' : 'vertical';
        }
        /* Get the start position and direction */
        if (this.panAxis === 'vertical') {
            /* Prevent vertical scrolling while are are swiping on the image */
            e.preventDefault();
            const height = e.currentTarget.clientHeight;
            const panPct = (-(yDiff / height) * 100).toFixed(2);
            const normalizedPanPct = Math.min(Math.max(0, panPct), 100);
            this.setState({panPct: normalizedPanPct});
            this.applyPanStyles({panPct: normalizedPanPct});
        }
    };

    onTouchEnd = () => {
        this.x = null;
        this.y = null;
        this.panAxis = null;
        if (this.touchMoved) {
            this.transition(this.state.panPct < 30); // 30% movement threshold
        }
        this.touchMoved = false;
    };

    render() {
        const {className, children, ...rest} = this.props;
        const classNames = classnames('BottomSheetModal', className, {
            'BottomSheetModal--no-footer': !this.props.footer
        });

        return (
            <Modal
                {...rest}
                className={classNames}
                modalAnimation="modal-from-bottom"
                onModalOpen={this.handleOpen}
                onModalClose={this.handleClose}
                enableTouchMove
            >
                {children}
            </Modal>
        );
    }
}

export default BottomSheet;
